module.exports = __webpack_public_path__ + "img/46.55c2cb13.jpg";